import { render, staticRenderFns } from "./DialogUpdatePriceRawMaterialGlobal.vue?vue&type=template&id=4aed038c&scoped=true&"
import script from "./DialogUpdatePriceRawMaterialGlobal.vue?vue&type=script&lang=js&"
export * from "./DialogUpdatePriceRawMaterialGlobal.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdatePriceRawMaterialGlobal.vue?vue&type=style&index=0&id=4aed038c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed038c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VDivider,VIcon,VSpacer})
